/* eslint-disable */
import LazyLoad from "vanilla-lazyload";
import inView from "in-view";
import gsap from "gsap";
import Flickity from "flickity";
import VanillaTilt from "vanilla-tilt";

const HTML = document.querySelector("html");

class App {
  constructor() {
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    if( isSafari ) HTML.classList.add('is-safari');


    this.lazyload = new LazyLoad({
      unobserve_entered: true,
      elements_selector: ".js-lazy",
      threshold: window.innerHeight * 0.8,
      // eslint-disable-next-line camelcase
      callback_enter: ($el) => {
        if ($el.classList.contains("js-lazy-error-placeholder")) {
          $el.lazyLoadPlaceholder = $el.src;
        } else if ($el.dataset.src == undefined) {
          const figure = $el.closest("figure");
          if (figure) figure.classList.add("img-is-loaded");
        }
      },
      callback_loaded: (el) => {
        const figure = el.closest("figure");
        if (figure) figure.classList.add("img-is-loaded");
      },
      // eslint-disable-next-line camelcase
      callback_error: ($el) => {
        if ($el.lazyLoadPlaceholder) {
          $el.src = $el.lazyLoadPlaceholder;
        }
      },
    });

    const tilts = document.querySelectorAll(".js-tilt");
    if (tilts) {
      VanillaTilt.init(tilts, {
        max: 25,
        speed: 200,
      });
    }

    /** TOGGLE MENU */
    const toggleMenu = document.querySelectorAll(".toggle-menu");
    if (toggleMenu.length) {
      toggleMenu.forEach((btn) => {
        btn.addEventListener("click", (e) => {
          e.preventDefault();
          HTML.classList.toggle("open-menu");
        });
      });
    }

    /** SUBMENU */
    const links = document.querySelectorAll(".menu-item-has-children");
    links.forEach((link) => {
      const submenu = link.querySelector(".sub-menu");
      link.addEventListener("mouseenter", () => {
        gsap.to(submenu, {
          duration: 0.3,
          ease: "power2.out",
          height: submenu.scrollHeight,
        });
      });
      link.addEventListener("mouseleave", () => {
        gsap.to(submenu, {
          duration: 0.3,
          ease: "power2.out",
          height: 0,
        });
      });
    });

    this.marqueeCarousel();
    this.carousel();
    this.slider();
    this.accordion();
    this.marquee();
    this.inViewport();
  }

  slider() {
    const elts = document.querySelectorAll(".slider");

    if (elts) {
      elts.forEach((el) => {
        const sliderBody = el.querySelectorAll(".slider-body .item");
        const sliderMedia = el.querySelectorAll(".slider-media figure");

        if (sliderBody && sliderMedia) {
          window.addEventListener("resize", () => {
            let maxHeight = 0;
            sliderBody.forEach((slide) => {
              if (slide.querySelector(".wysiwyg").scrollHeight > maxHeight)
                maxHeight = slide.querySelector(".wysiwyg").scrollHeight;
            });

            gsap.set(el.querySelector(".slider-body"), {
              height: maxHeight,
            });
          });
          window.dispatchEvent(new Event("resize"));

          let current = -1;
          let isAnimating = false;
          const totalSlides = sliderMedia.length;

          function reorder() {
            for (let i = current; i < totalSlides; i++) {
              gsap.set(sliderMedia[i], {
                zIndex: totalSlides - i + 1,
              });
            }
            for (let i = 0; i < current; i++) {
              gsap.set(sliderMedia[i], {
                zIndex: totalSlides - current - i,
              });
            }
          }
          reorder();

          function goto(index, direction) {
            let delay = 0;
            if (isAnimating) return;

            isAnimating = true;

            if (sliderMedia[current]) {
              const currentMedia = sliderMedia[current];
              if (direction == 1) {
                gsap.to(currentMedia, {
                  scale: 1.1,
                  rotate: `${(current % 2 == 0 ? -1 : 1) * 3}deg`,
                  autoAlpha: 0,
                  ease: "power2.inOut",
                  duration: 0.3,
                  onComplete: () => {
                    reorder();
                    gsap.set(currentMedia, { clearProps: "transform" });
                    gsap.to(currentMedia, {
                      autoAlpha: 1,
                      duration: 0.1,
                    });
                  },
                });
              }
            }

            if (sliderBody[current]) {
              sliderBody[current].classList.add('pointer-events-none');
              gsap.to(sliderBody[current].querySelector(".wysiwyg").children, {
                duration: 0.3,
                ease: "circ.in",
                autoAlpha: 0,
                y: `${direction > 0 ? "-2.5rem" : "2.5rem"}`,
                stagger: 0.05,
              });

              delay = 0.3;
            }

            if (sliderMedia[index] && direction == -1) {
              gsap.fromTo(
                sliderMedia[index],
                {
                  scale: 1.1,
                  rotate: `${(current % 2 == 0 ? -1 : 1) * 6}deg`,
                  autoAlpha: 0,
                  zIndex: sliderMedia.length + 1,
                },
                {
                  autoAlpha: 1,
                  rotate: `${(current % 2 == 0 ? -1 : 1) * 4}deg`,
                  scale: 1,
                  ease: "power2.inOut",
                  duration: 0.3,
                  onComplete: () => {
                    reorder();
                  },
                }
              );
            }

            if (sliderBody[index]) {
              sliderBody[index].classList.remove('pointer-events-none');

              gsap.set(sliderBody[index], {
                autoAlpha: 1,
              });
              gsap.fromTo(
                sliderBody[index].querySelector(".wysiwyg").children,
                {
                  autoAlpha: 0,
                  y: `${direction > 0 ? "2.5rem" : "-2.5rem"}`,
                },
                {
                  duration: 0.4,
                  ease: "expo.out",
                  autoAlpha: 1,
                  y: "0rem",
                  stagger: 0.05,
                  delay,
                  onComplete() {
                    isAnimating = false;
                  },
                }
              );
            }

            current = index;
          }

          el.addEventListener("inview", () => {
            if (current === -1) {
              goto(0, 1);
            }
          });

          const next = el.querySelector(".next");
          if (next) {
            next.addEventListener("click", (e) => {
              e.preventDefault();
              goto(current + 1 < sliderBody.length ? current + 1 : 0, 1);
            });
          }

          const prev = el.querySelector(".prev");
          if (prev) {
            prev.addEventListener("click", (e) => {
              e.preventDefault();
              goto(current - 1 >= 0 ? current - 1 : sliderBody.length - 1, -1);
            });
          }
        }
      });
    }
  }

  accordion() {
    const elts = document.querySelectorAll(".accordion");

    if (elts) {
      elts.forEach((accordion) => {
        const items = accordion.querySelectorAll(".accordion-item");
        const headers = accordion.querySelectorAll(".accordion-header");
        const contents = accordion.querySelectorAll(".accordion-content");

        if (headers && items && contents) {
          headers.forEach((header, index) => {
            header.addEventListener("click", (e) => {
              e.preventDefault();

              items[index].classList.toggle("is-open");

              gsap.to(contents[index], {
                duration: 0.3,
                ease: "circ.inOut",
                autoAlpha: items[index].classList.contains("is-open") ? 1 : 0,
                height: items[index].classList.contains("is-open")
                  ? contents[index].scrollHeight
                  : 0,
              });
            });
          });
        }
      });
    }
  }

  carousel() {
    const elts = document.querySelectorAll(".carousel");

    if (elts) {
      elts.forEach((el) => {
        const progressBar = document.createElement("div");
        progressBar.classList.add("carousel-progress");
        const bar = document.createElement("div");
        bar.classList.add("bar");
        progressBar.append(bar);

        new Flickity(el, {
          contain: true,
          cellAlign: "left",
          pageDots: false,
          draggable: true,
          on: {
            ready() {
              el.append(progressBar);
            },
            scroll(progress) {
              progress = Math.max(0, Math.min(1, progress));
              gsap.to(bar, {
                width: `${progress * 100}%`,
                ease: "power2.out",
                duration: 0.3,
              });
            },
          },
        });
      });
    }
  }

  marquee() {
    const elts = document.querySelectorAll(".marquee .line");
    if (elts) {
      elts.forEach((track) => {
        track.innerHTML += track.innerHTML;

        this.lazyload.update();

        const direction = track.dataset.dir || -1; // 1 = vers la gauche, -1 = vers la droite
        const speed = 40; // pixels par seconde
        let x = 0; // position actuelle
        let wrapWidth; // largeur d’un bloc A
        let lastScrollY = window.scrollY;
        const timer = 0;

        function computeWrapWidth() {
          // On divise par 2 car on a mis A + A
          wrapWidth = track.scrollWidth / 2;
        }

        // 2) Calcul initial + recalcul au resize
        window.addEventListener("load", computeWrapWidth);
        window.addEventListener("resize", computeWrapWidth);

        // 3) Détection du sens de scroll
        window.addEventListener(
          "scroll",
          () => {
            const currentScrollY = window.scrollY;

            // if (currentScrollY > lastScrollY) {
            //   // Scroll vers le bas → texte va vers la gauche
            //   direction = 1;
            // } else if (currentScrollY < lastScrollY) {
            //   // Scroll vers le haut → texte va vers la droite
            //   direction = -1;
            // }

            lastScrollY = currentScrollY;
          },
          { passive: true }
        );
        track.addEventListener("mouseenter", () => {
          gsap.ticker.remove(animate);
        });
        track.addEventListener("mouseleave", () => {
          lastTime = performance.now();
          gsap.ticker.add(animate);
        });

        // 4) Animation avec GSAP.ticker (boucle infinie)
        let lastTime = performance.now();

        function animate() {
          const now = performance.now();
          const dt = (now - lastTime) / 1000; // secondes écoulées
          lastTime = now;

          if (!wrapWidth) return; // au cas où le layout n’est pas encore prêt

          // Mise à jour de la position en fonction du temps, de la vitesse et du sens
          x += direction * speed * dt;

          // 5) Normalisation dans l’intervalle [-wrapWidth, 0]
          //    pour boucler proprement dans les deux sens.
          if (x <= -wrapWidth) {
            x += wrapWidth;
          } else if (x >= 0) {
            x -= wrapWidth;
          }

          gsap.set(track, { x }); // applique transform: translateX(x)
        }

        gsap.ticker.add(animate);
      });
    }
  }

  marqueeCarousel() {
    const elts = document.querySelectorAll(".marquee-carousel");

    if (elts) {
      elts.forEach((el) => {
        const flkty = new Flickity(el, {
          wrapAround: true,
          prevNextButtons: false,
          pageDots: false,
          draggable: true,
          cellAlign: "center",
        });

        let lastScrollY = window.scrollY;
        let timer = 0;
        const coeff = 0.3;
        const speed = -1; // direction par défaut

        // Détection du scroll
        window.addEventListener("scroll", function () {
          // if (window.scrollY > lastScrollY) {
          //   speed = -1; // scroll vers le bas → gauche
          // } else {
          //   speed = 1; // scroll vers le haut → droite
          // }
          lastScrollY = window.scrollY;
        });

        el.addEventListener("mouseenter", () => {
          cancelAnimationFrame(timer);
        });
        el.addEventListener("mouseleave", () => {
          animate();
        });

        // Animation continue
        function animate() {
          flkty.x += speed * coeff;
          flkty.positionSlider();
          timer = requestAnimationFrame(animate);
        }

        animate();
      });
    }
  }

  inViewport() {
    // In viewport
    inView.offset({
      bottom: window.innerHeight * 0.1,
    });
    inView(".js-reveal:not(.is-visible)")
      .on("enter", function (elt) {
        elt.dispatchEvent(new Event("inview"));
        elt.classList.add("is-visible");
        elt.classList.remove("not-visible");

        const video = elt.querySelector("video");

        if (
          (elt.tagName == "VIDEO" && elt.dataset.autoplay == "true") ||
          (video && video.dataset.autoplay == "true")
        ) {
          const v = video || elt;
          const playPromise = v.play();
          if (playPromise !== null) {
            playPromise.catch(() => {
              v.play();
            });
          }
        }
      })
      .on("exit", function (elt) {
        const video = elt.querySelector("video");
        if (
          (elt.tagName == "VIDEO" && elt.dataset.autoplay != "") ||
          (video && video.dataset.autoplay != "")
        ) {
          const v = video || elt;
          v.pause();
        }

        elt.dispatchEvent(new Event("outview"));
        elt.classList.add("not-visible");
      });
  }
}

window.addEventListener("DOMContentLoaded", () => {
  new App();
});
